import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ProfilePage from '../components/pages/ProfilePage/ProfilePage';
import TravelCompanionPage from './pages/TravelCompanionPage/TravelCompanionPage';
import PaymentMethodsPage from './pages/PaymentMethodsPage/PaymentMethodsPage';
import PersonalInfoPage from './pages/PersonalInfoPage/PersonalInfoPage';
import Navigator from '../utils/Navigator';
import ProfileStore from '../state/ProfileStore';
import ActiveSessionsPage from './pages/ActiveSessionsPage/ActiveSessionsPage';
import DeleteAccountPage from './pages/DeleteAccountPage/DeleteAccountPage';
import Environment from '../utils/Environment';
import UpaTracker from '../tracking/UpaTracker';
import DataLayerTracker from '../tracking/DataLayerTracker';
import { AddEmailPage } from './commons/AddEmailPage/AddEmailPage';

const {
  profilePage, personalInfoPage, verifyEmailPage, paymentMethodsPage, travelCompanionsPage, communicationSettingsPage, activeSessionsPage, deleteAccountPage,
} = Navigator;

const profileStore = new ProfileStore();
const { emails } = profileStore.personalInfoStore;

class App extends React.Component {
  constructor(props) {
    super(props);

    UpaTracker.trackPageview();
    DataLayerTracker.trackShoppingDataReady();

    if (Environment.redirectUrl) {
      UpaTracker.track('redirect');
      window.location.href = Environment.redirectUrl;
    }
  }

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path={profilePage}
            render={({ location }) => (
              <ProfilePage
                isMerging={profileStore.isMerging}
                profile={profileStore}
                clustersErrors={profileStore.clustersErrorsStore}
                location={location}
                isWhiteLabel={Environment.isWhiteLabel}
                whiteLabelFeatures={Environment.whiteLabelFeatures}
              />
            )}
          />
          <Route
            path={communicationSettingsPage}
            render={({ location }) => (
              <ProfilePage
                isMerging={profileStore.isMerging}
                profile={profileStore}
                clustersErrors={profileStore.clustersErrorsStore}
                location={location}
                isWhiteLabel={Environment.isWhiteLabel}
              />
            )}
          />
          <Route
            path={personalInfoPage}
            render={({ location }) => (
              <PersonalInfoPage
                profileStore={profileStore}
                personalInfo={profileStore.personalInfoStore}
                clustersErrors={profileStore.clustersErrorsStore}
                location={location}
              />
            )}
          />
          <Route
            path={verifyEmailPage}
            render={() => (
              <AddEmailPage />
            )}
          />
          <Route
            path={paymentMethodsPage}
            render={() => (
              <PaymentMethodsPage
                isMerging={profileStore.isMerging}
                creditCards={profileStore.creditCardsStore}
                billingProfiles={profileStore.billingProfilesStore}
                clustersErrors={profileStore.clustersErrorsStore}
                isBillingProfileSectionAvailable={profileStore.isBillingProfileSectionAvailable}
              />
            )}
          />
          <Route
            path={travelCompanionsPage}
            render={() => (
              <TravelCompanionPage
                isMerging={profileStore.isMerging}
                travelCompanions={profileStore.travelCompanionsStore}
                clustersErrors={profileStore.clustersErrorsStore}
              />
            )}
          />
          <Route
            path={activeSessionsPage}
            render={() => (
              <ActiveSessionsPage
                isMerging={profileStore.isMerging}
                activeSessionPage={profileStore.activeSessionPageStore}
                clustersErrors={profileStore.clustersErrorsStore}
              />
            )}
          />
          <Route
            path={deleteAccountPage}
            render={() => (
              <DeleteAccountPage
                isMerging={profileStore.isMerging}
                loyalty={profileStore.loyaltyStore}
                clustersErrors={profileStore.clustersErrorsStore}
                primaryEmail={!profileStore.clustersErrorsStore.emails ? emails.filter(email => email.isPrimary).pop().email : undefined}
              />
            )}
          />
        </Switch>
      </BrowserRouter>

    );
  }
}

export default App;
